module.exports = {
  WEEKDAYS: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  MONTHS: [
    ['январь', 'января'],
    ['февраль', 'февраля'],
    ['март', 'марта'],
    ['апрель', 'апреля'],
    ['май', 'мая'],
    ['июнь', 'июня'],
    ['июль', 'июля'],
    ['август', 'августа'],
    ['сентябрь', 'сентября'],
    ['октябрь', 'октября'],
    ['ноябрь', 'ноября'],
    ['декабрь', 'декабря'],
  ],
  SMARTPHONE_TYPE: [
    { caption: 'Андроид', value: 'android' },
    { caption: 'IOS', value: 'ios' },
    { caption: 'Нет', value: 'none' },
  ],

  // Регулярное выражение для валидации номера телефона
  PHONE_REGEX: /^([78])(\d{10})$/,

  ORDER_OPERATION_TYPES: {
    INCREASE_SALARY_20_PERCENT: 'increase_salary_20_percent',
  },

  EMAIL_REGEXP: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};
